import script from "./sf-tab-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-tab-item.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__